
import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Plus, Zap, Users, BarChart3 } from "lucide-react";
import FunnelsTab from "./FunnelsTab";
import EnrollmentsTab from "./EnrollmentsTab";
import AnalyticsTab from "./AnalyticsTab";

const SalesFunnelsModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState("funnels");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Sales Funnels</h1>
          <p className="text-muted-foreground">
            Create and manage automated communication sequences
          </p>
        </div>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          New Funnel
        </Button>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="funnels" className="flex items-center gap-2">
            <Zap className="h-4 w-4" />
            Funnels
          </TabsTrigger>
          <TabsTrigger value="enrollments" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            Enrollments
          </TabsTrigger>
          <TabsTrigger value="analytics" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Analytics
          </TabsTrigger>
        </TabsList>

        <TabsContent value="funnels" className="space-y-4">
          <FunnelsTab />
        </TabsContent>

        <TabsContent value="enrollments" className="space-y-4">
          <EnrollmentsTab />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-4">
          <AnalyticsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SalesFunnelsModule;
